import { render } from "./HelpBox.vue?vue&type=template&id=3d3c843e&scoped=true"
import script from "./HelpBox.vue?vue&type=script&lang=js"
export * from "./HelpBox.vue?vue&type=script&lang=js"

import "./HelpBox.vue?vue&type=style&index=0&id=3d3c843e&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3c843e"]])

export default __exports__